import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../app/hooks';
import Errors from '../../../components/errors';
import Loader from '../../../components/loader';

import { getStratigraphyLexicons, 
         selectStratigraphy, 
         updateStratigraphyLexicon, 
         addRow, 
         addStratigraphyLexicon, 
         deleteAddingRow,
         deleteStratigraphyLexicon } from "../../../services/stratigraphySlice";
import List from './list';

const ListStratigraphyLexicons = ({}:any) => {
  
  const dispatch = useAppDispatch();       
  useEffect(() => {        
    dispatch(getStratigraphyLexicons());
  }, []);

  const { 
    stratigraphyLexicons,
    loading,
    error,
    addingLexicon
  } = useSelector(selectStratigraphy); 

  const onUpdateStratigraphyLexicon = (stratigraphyLexicon: any) => {
    return dispatch(updateStratigraphyLexicon(stratigraphyLexicon));    
  }

  const onAddStratigraphyLexicon = (stratigraphyLexicon: any) => {
    return dispatch(addStratigraphyLexicon(stratigraphyLexicon));
  };

  const onAdd = () => {
    dispatch(addRow());
  };

  const onDeleteAddingRow = () => {
    dispatch(deleteAddingRow());
  };

  const onDeleteStratigraphyLexicon = (stratigraphyLexiconId: any) => {
    dispatch(deleteStratigraphyLexicon(stratigraphyLexiconId));
  }
    
    return (
        <section className="section">
            <div>
                <div className='columns'>
                  <div className="column">
                    <h1>Stratigraphy Lexicons</h1>   
                  </div>                  
                </div>                
                <button className="button" onClick={onAdd} disabled={addingLexicon}>Add</button>
                {(loading) && <Loader/>}
                <Errors error={error}/>
                
                <List stratigraphyLexicons={stratigraphyLexicons} 
                      updateStratigraphyLexicon={onUpdateStratigraphyLexicon}
                      addStratigraphyLexicon={onAddStratigraphyLexicon}
                      deleteAddingRow={onDeleteAddingRow}
                      deleteStratigraphyLexicon={onDeleteStratigraphyLexicon} />
            </div>
        </section>
    )    
};

export default ListStratigraphyLexicons;